import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toast } from "react-toastify";
import { messageAdd, messageGetSingle, messageUpdate } from "actions/message/requests";
import { moduleGetSearch } from "actions/module/requests";
import Spinner from "../../lib/components/Spinner";

const RentsEdit = (props) => {
  const {
    match,
    messageGetSingle,
    moduleLoading,
    loading,
    moduleList,
    moduleGetSearch
  } = props;
  const paramId = match && match.params && match.params.id ? match.params.id : false;

  const [id, setId] = useState("");
  const [description, setDescription] = useState("");
  const [module, setModule] = useState("");
  const [isEdit, setIsEdit] = useState(false);

  const handleSubmit = (ev) => {
    ev.preventDefault();
    const data = {
      id: `${module.toUpperCase()}_${id}`,
      description,
      module
    };

    messageGetSingle(paramId, single => {
      if (single) {
        toast((<div>Translation for `{data.id}` already exists.</div>), { type: toast.TYPE.ERROR, });
        return null;
      }
      props.messageAdd(data, () => {
        props.history.push("/translation");
      });
    });
  };

  useEffect(() => {
    if (paramId) {
      messageGetSingle(paramId, single => {
        if (!single) return;

        setIsEdit(true);
        setId(single.id.replace(`${single.module.toUpperCase()}_`, ""));
        setDescription(single.description);
        setModule(single.module);
      });
    }
  }, [paramId, messageGetSingle]);

  useEffect(() => {
    if (!moduleList.length) {
      moduleGetSearch(0, 10000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!id && moduleList.length) {
      setModule(moduleList[0].id);
    }
  }, [id, moduleList]);

  return (
    <div className="w-100 p-2">
      {loading || moduleLoading ? <Spinner/> : null}
      <div className="card">
        <div className="card-header">
          <h4>Translation Message</h4>
        </div>
        <div className="card-body">
          <form
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <div className="mb-3">
              <label>Module</label>
              <select
                className="form-control"
                value={module}
                onChange={ev => setModule(ev.target.value)}
                disabled={isEdit}
              >
                {moduleList.map(item => (
                  <option key={item.id} value={item.id}>{item.id}</option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label>ID</label>
              <div className="input-group">
                <span className="input-group-text">{module.toUpperCase()}_</span>
                <input
                  className="form-control"
                  type="text"
                  value={id}
                  placeholder="title"
                  onChange={ev => setId(ev.target.value)}
                  disabled={isEdit}
                />
              </div>
            </div>
            <div className="mb-3">
              <label>Description</label>
              <textarea
                className="form-control"
                value={description}
                placeholder="This key use for website title"
                onChange={ev => setDescription(ev.target.value)}
              />
            </div>

            <hr/>

            <div className="text-end">
              <button
                className="btn btn-success"
                onClick={handleSubmit}
                disabled={false}
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  loading: state.message.loading,
  moduleList: state.module.list.content,
  moduleLoading: state.module.loading,
});

const mapStateToDispatch = dispatch => ({
  messageAdd: bindActionCreators(messageAdd, dispatch),
  messageUpdate: bindActionCreators(messageUpdate, dispatch),
  messageGetSingle: bindActionCreators(messageGetSingle, dispatch),
  moduleGetSearch: bindActionCreators(moduleGetSearch, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(RentsEdit);



// WEBPACK FOOTER //
// ./src/views/pages/Translation/edit.js